<div class="header-wrapper">
  <div class="mat-h2">{{ 'Invitations' | translate }}</div>
  <div class="header-wrapper-right-button">
    <div
      [matTooltip]="
      this.selection.hasValue()
          ? ('Resend_Invitation' | translate)
          : ('Resend_Invitations_Disabled' | translate)
      "
    >
      <button
        mat-stroked-button
        color="primary"
        aria-label="resend"
        mat-button=""
        (click)="resendconfirmation()"
        [disabled]="!this.selection.hasValue()"
      >
        <mat-icon>refresh</mat-icon>
        {{ 'COMPANY_USERS.resend_invitation' | translate }}
      </button>
    </div>
    <div
      [matTooltip]="
      this.selection.hasValue()
          ? ('Delete_User_Invite' | translate)
          : ('Delete_User_Invite_Disabled' | translate)
      "
    >
      <button
        mat-stroked-button
        color="primary"
        aria-label="trash"
        mat-button=""
        (click)="confirmDelete()"
        [disabled]="!this.selection.hasValue()"
      >
        <mat-icon>delete_outline</mat-icon>
        {{ 'COMPANY_DELETE_USERS.delete_invite' | translate }}
      </button>
    </div>
    <div [matTooltip]="'Invite_Users' | translate">
      <button
        mat-stroked-button
        color="primary"
        aria-label="invite"
        mat-button=""
        (click)="inviteUsers()"
      >
        <mat-icon>send</mat-icon>
        {{ 'Invite_Users' | translate }}
      </button>
    </div>
  </div>
</div>
<table mat-table [dataSource]="invitesDataSource">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        color="primary"
        (change)="$event ? masterToggle() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="isPartiallySelected()"
        [disabled]="invitesDataSource === undefined"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef width="50%">
      {{ 'COMPANY_USERS.email' | translate }}
    </th>
    <td mat-cell *matCellDef="let invite">{{ invite.email }}
      @if (invite.isCompanyManager) {
      <mat-chip class="company-admin">
        {{'COMPANY_ADD_USERS.admin' | translate | uppercase}}
      </mat-chip>
      }
      @if (isBranchAdmin(invite)) {
      <mat-chip class="branch-admin">
        {{'COMPANY_ADD_USERS.branch_admin' | translate | uppercase}}
      </mat-chip>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef width="50%">
      {{ 'COMPANY_USERS.status' | translate }}
    </th>
    <td mat-cell *matCellDef="let invite">{{ invite.status }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>
<mat-paginator
  #paginator
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
></mat-paginator>
@if (_invitationsService.loading || !allSubscriptionsCompleted) {
<app-spinner></app-spinner>
}
